<template>
	<el-card v-show="exercise.length > 0">
		<div slot="header" class="exercise header">
			<img src="../image/exercise.png" style="margin-left:1px">
			<span>Activities</span>
		</div>
		<ExerciseTable :patient="patient"
			v-bind:exercise="exercise">
		</ExerciseTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import ExerciseTable from './Table'

export default {
	name: 'patient-exercise-card',
	extends: OverviewCard,

	computed: {
		exercise() {
			return this.patientEventType('exercise')
		}
	},

	components: {
		ExerciseTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
